<template>
    <div v-show="visible" class="c-float-bottom">
        <div class="l-element c-float-bottom-background">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "FloatBottom",
    props: {
        /**
         * 表示させたいスクロール深度
         */
        scrollDepth: {
            type: Number,
            required: false,
            default: 0
        },
    },
    data() {
        return {
            visible: false,
            scrollY: 0
        }
    },
    created() {
        //scrollDepth=0（最初からボタン表示）だった時のために最初に一度実行する
        this.handleScroll()
        window.addEventListener("scroll", this.handleScroll);
    },
    unmounted() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {
            this.scrollY = window.scrollY
            if(!this.visible) {
                if(this.scrollY >= this.scrollDepth) {
                    return this.visible = true
                }
            } else if(this.visible) {
                if(this.scrollY < this.scrollDepth) {
                    return this.visible = false
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@use "../../../scss/v2/base/variables";
// 基本の余白
$grid-base: 4.27vw; //375px幅に対して16px
$grid-consistent: $grid-base * 0.5; //375px幅に対して8px

.c-float-bottom {
    position: sticky;
    position: -webkit-sticky;
    bottom: 0;
    display: block;
    z-index: 3;
    margin: -$grid-consistent;
    &-background {
        background: variables.$color-white;
        border-top: 1px solid variables.$color-pictlink-black-20;
    }
}
</style>
